import { render, staticRenderFns } from "./treatment-create-order.html?vue&type=template&id=54c470e2&scoped=true&"
import script from "./treatment-create-order.js?vue&type=script&lang=js&"
export * from "./treatment-create-order.js?vue&type=script&lang=js&"
import style0 from "./treatment-create-order.scss?vue&type=style&index=0&id=54c470e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c470e2",
  null
  
)

export default component.exports